// removed by extract-text-webpack-plugin
module.exports = {"content":"styles__content___3B6aw","wrapIndent":"styles__wrapIndent___11U3P","indent":"styles__indent___1IU6i","privacy":"styles__privacy___232EG","linksList":"styles__linksList___1f7WB"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TermsAndConditions/styles.scss
// module id = 443
// module chunks = 0